import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Carousel from '../../../components/carousel/Carousel.js';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: '9rem 0',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  title: {
    padding: '0',
    width: '100%',
    textAlign: 'center',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      padding: '0 1.5rem',
    },
  },
  text: {
    width: '100%',
    textAlign: 'center',
    lineHeight: '2rem',
    marginBottom: '4rem',
    padding: '0 10rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      padding: '0 1.5rem',
    },
  },
}));

const CarouselSection = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container maxWidth="lg" fixed disableGutters>
        <Grid item md={12}>
          <Typography variant="h1" color="primary" className={classes.title}>
            Hear what others think before you choose a provider.
          </Typography>
          <Typography variant="h3" className={classes.text}>
            Clickability is your <b>Number 1</b> source for reviews and ratings of disability services by people who have used them. Check out some of the latest reviews below or find the providers you&apos;re considering and see what others say about their experiences.
          </Typography>
        </Grid>
      </Container>
      <Carousel />
    </div>
  );
};

export default CarouselSection;
